import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import { setMenuSelected, setMenuSelected_2 } from '@redux/actions/menuAction';
import { getList, exportData } from 'api/cosoApi';
import slug from 'constants/slug';
import styled from 'styled-components';
import { createForm } from 'rc-form';
import PageLockHOC from 'hoc/pageLock';
import { COLOR } from 'config';
import {
  isFacilityEiaEligible,
  isFacilityPermitEligible,
  isFacilityEmissionEligible,
} from 'utils/facilityUtil';
import { IS_ENTERPRISE } from 'config';
import { getLabelIndustrialArea } from 'utils/misc';
import { Tooltip } from '@blueprintjs/core';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

const DEFAULT_ID_FACILITYPERMIT = 10;
const DEFAULT_ID_FACILITYEIA = 27;

@PageLockHOC(['facility.view'])
class CosoList extends BaseListContainer {
  constructor(props) {
    const funcApi = {
      getList,
      exportData,
    };

    const columns = [
      {
        dataField: 'FacilityNameFull',
        text: 'Tên cơ sở/dự án',
        formatter: (cell, row) => {
          return (
            <Link
              to={slug.CO_SO.VIEW_WITH_ID + row._id}
              onClick={() => {
                this.props.setMenuSelected_2(null);
              }}
              target='_blank'
            >
              <NameContainer style={{ width: 200 }}>
                <span>{cell}</span>
              </NameContainer>
            </Link>
          );
        },
      },
      ...(!IS_ENTERPRISE && [
        {
          dataField: 'organizationName',
          text: 'Tên doanh nghiệp',
          formatter: (cell, row) => {
            return <div style={{ width: 200 }}>{cell ? cell : ''}</div>;
          },
        },
      ]),
      {
        dataField: 'industrialArea',
        text: getLabelIndustrialArea(),
        formatter: (cell, row) => {
          return <div style={{ width: 40 }}>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'sector',
        text: 'Ngành/Nghề',
        formatter: (cell, row) => {
          return <div style={{ width: 120 }}>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'businessActivity',
        text: 'Tình trạng hoạt động',
        formatter: (cell, row) => {
          return (
            <div style={{ width: 90 }}>
              {cell && cell.value ? cell.Name || cell.label : ''}
            </div>
          );
        },
      },
      ...(IS_ENTERPRISE && [
        {
          classes: 'children-td',
          dataField: 'facilityeias',
          text: 'Hồ sơ môi trường',
          headerFormatter: () => {
            const facilityeiasLength = this.facilityeias
              ? this.facilityeias.length
              : 0;

            const facilityeiaHeaders =
              this.facilityeias &&
              this.facilityeias.map((facilityeia) => (
                <Tooltip content={facilityeia.Name || ''}>
                  <th className='child-column' key={facilityeia._id}>
                    {facilityeia.Name || ''}
                  </th>
                </Tooltip>
              ));

            return (
              <table style={{ width: '100%' }}>
                <thead style={{ textAlign: 'center' }}>
                  <tr>
                    <th colSpan={facilityeiasLength}>Hồ sơ môi trường</th>
                  </tr>

                  <tr style={{ display: 'flex' }}>
                    {facilityeiasLength > 0 && facilityeiaHeaders}
                  </tr>
                </thead>
              </table>
            );
          },
          formatter: (_, row) => {
            const facilityeiasLength = this.facilityeias
              ? this.facilityeias.length
              : 0;
            const currentFacilityeias = row.facilityeias;
            const currentFacilityeiasSet = new Set(
              currentFacilityeias.map((item) => item.Title)
            );

            if (currentFacilityeias.length === 0 || facilityeiasLength === 0) {
              return null;
            }

            const renderFacilityeiaColumn = (facilityeia) => {
              const hasFacilityeia = currentFacilityeiasSet.has(
                facilityeia.Name
              );

              return (
                <th className='child' style={{ textAlign: 'center' }}>
                  {hasFacilityeia && (
                    <img
                      height={14}
                      alt='check-icon'
                      src='/icons/badge-check.png'
                    />
                  )}
                </th>
              );
            };

            return <tr>{this.facilityeias.map(renderFacilityeiaColumn)}</tr>;
          },
        },
        {
          classes: 'children-td',
          dataField: 'facilitypermits',
          text: 'Giấy phép',
          headerFormatter: () => {
            const facilitypermitsLength = this.facilitypermits
              ? this.facilitypermits.length
              : 0;
            const facilitypermitHeaders =
              this.facilitypermits &&
              this.facilitypermits.map((facilitypermit) => (
                <Tooltip content={facilitypermit.Name || ''}>
                  <th className='child-column' key={facilitypermit._id}>
                    {facilitypermit.Name || ''}
                  </th>
                </Tooltip>
              ));

            return (
              <table style={{ width: '100%' }}>
                <thead style={{ textAlign: 'center' }}>
                  <tr>
                    <th colSpan={facilitypermitsLength}>Giấy phép</th>
                  </tr>

                  <tr style={{ display: 'flex' }}>
                    {facilitypermitsLength > 0 && facilitypermitHeaders}
                  </tr>
                </thead>
              </table>
            );
          },
          formatter: (_, row) => {
            const facilitypermitsLength = this.facilitypermits
              ? this.facilitypermits.length
              : 0;

            const currentFacilitypermits = row.facilitypermits;

            const currentFacilitypermitsSet = new Set(
              currentFacilitypermits.map(
                (item) => item.permitType && item.permitType._id
              )
            );

            if (
              currentFacilitypermits.length === 0 ||
              facilitypermitsLength === 0
            ) {
              return null;
            }

            const renderFacilitypermitColumn = (facilityeia) => {
              const hasFacilitypermit = currentFacilitypermitsSet.has(
                facilityeia._id
              );

              return (
                <th className='child' style={{ textAlign: 'center' }}>
                  {hasFacilitypermit && (
                    <img
                      height={14}
                      alt='check-icon'
                      src='/icons/badge-check.png'
                    />
                  )}
                </th>
              );
            };

            return (
              <tr>{this.facilitypermits.map(renderFacilitypermitColumn)}</tr>
            );
          },
        },
      ]),
    ];

    super(props, funcApi, columns, slug.CO_SO.CREATE, 'facility');

    this.facilityeias = this.props.lookupitems[DEFAULT_ID_FACILITYEIA];
    this.facilitypermits = this.props.lookupitems[DEFAULT_ID_FACILITYPERMIT];

    this.state = {
      ...this.state,
    };
  }

  isFacilityEligible(facility) {
    return (
      isFacilityEiaEligible(facility) &&
      isFacilityPermitEligible(facility) &&
      isFacilityEmissionEligible(facility)
    );
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
  ...state.lookupitems,
});

const mapDispatchToProps = {
  setMenuSelected,
  setMenuSelected_2,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(createForm()(CosoList))
);



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoList/index.js